import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const BrandList = React.lazy(() => import('components/Brand/List/List'));

function ScreensBrandsList() {
  return (
    <BaseLayout>
      <DocumentTitle>Brands Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <BrandList />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensBrandsList;
